<template>
    <div>
        <template v-if="editar">
            <Curso titulo="Editar Curso" estado="editar" />
        </template>
        <template v-else>
        <b-row class="border-bottom" style="background-color: rgba(255,225,0,0.1);">
            <b-col cols="3" class="pt-3">
                <b-breadcrumb :items="migas"></b-breadcrumb>
            </b-col>
            <b-col cols="9" class="border-left text-left pt-3">
                <b-button id="btn_editar_curso" variant="link" @click="editar=!editar">
                    <b-icon icon="pencil-square" font-scale="2" variant="info"></b-icon>
                </b-button>
                <b-tooltip target="btn_editar_curso">Editar curso</b-tooltip>
                <template v-if="indiceSel > -1">
                    <b-button id="btn_editar_alumno" variant="link" @click="editarAlumno">
                        <b-icon icon="pencil" font-scale="2" variant="info"></b-icon>
                    </b-button>
                    <b-tooltip target="btn_editar_alumno">Editar alumno y/o notas</b-tooltip>
                    <b-button id="btn_eliminar_alumno" variant="link" @click="eliminarAlumno">
                        <b-icon icon="trash" font-scale="2" variant="info"></b-icon>
                    </b-button>
                    <b-tooltip target="btn_eliminar_alumno">Eliminar alumno</b-tooltip>
                </template>
            </b-col>
        </b-row>
        <div class="table-responsive">
            <CabeceraPlanilla titulo="BOLETIN DE PROMOCION ANUAL" />
            <b-table
                responsive
                flex
                striped
                hover
                small
                ref="alumnos"
                table-class="text-nowrap"
                selectable
                select-mode="single"
                head-variant="dark"
                :items="alumnos"
                :fields="campos"
                selected-variant="info"
                @row-selected="onRowSelected"
                @row-clicked="onRowClicked"
            >
                <template v-slot:thead-top="">
                    <b-tr>
                        <b-th colspan="2"><span class="sr-only">Nro y Nombres</span></b-th>
                        <b-th colspan="3" v-for="(mat, index) of materias" :key="index">{{mat.label}}</b-th>
                        <b-th><span class="sr-only">Observacion</span></b-th>
                        <b-th><span class="sr-only">Verificado</span></b-th>
                    </b-tr>
                </template>
                <template v-slot:cell(index)="data">
                    {{data.index+1}}
                </template>
                <template v-slot:cell(verificado)="data">
                    {{data.value?"Si":"No"}}
                </template>
            </b-table>
            <b-card>
                <b-row>
                    <b-col>
                        <b-form-group label-for="nombre" label="Apellidos y Nombres" description="Ingrese nombre completo del alumno">
                        <b-form-input
                            id="nombre"
                            placeholder="Ingrese nombre completo"
                            ref="nombre"
                            v-model="nombre"
                            class="mb-2"
                            autocomplete="off"
                            trim
                            :formatter="formatear"
                            :state="validarNombre"
                            @change="editarNombre"
                        >
                        </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label-for="verificado" label="¿Verificado?" description="Marque si está verificado">
                        <b-form-checkbox
                            id="verificado"
                            ref="verificado"
                            v-model="verificado"
                            class="mb-2"
                            @input="onChangeCheckbox"
                        >
                        </b-form-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label-for="nota" :label="materias[puntero]?materias[puntero].label:'Default'" description="Ingrese nota(s) entre 1 y 70">
                        <b-form-tags
                            input_id="nota"
                            placeholder="Ingrese nota(s)"
                            ref="nota"
                            v-model="nota"
                            separator="+"
                            no-add-on-enter
                            remove-on-delete
                            add-on-change
                            class="mb-2"
                            @keydown.enter.native.prevent="onTeclaEnter"
                            @keydown.left.native="onTeclaLeft"
                            @keydown.esc.native="onTeclaScape"
                            :state="validarCantidad"
                            :tag-validator="validarNota"
                            duplicate-tag-text=""
                            add-button-text=""
                            invalid-tag-text="Solo numeros, maximo 2 digitos"
                        >
                        </b-form-tags>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-row>
                            <b-col>
                                <b-form-group label-for="obs" label="Obs." label-align-sm="left">
                                <b-form-input
                                    id="obs"
                                    ref="obs"
                                    v-model="obs"
                                    style="width:95px"
                                    trim
                                    list="listaObs"
                                    :formatter="formatear"
                                    :state="validarObs"
                                    @keyup.enter.native="agregarObs"
                                >
                                </b-form-input>
                                <b-form-datalist
                                    id="listaObs"
                                    :options="valoresObs"
                                >
                                </b-form-datalist>
                                </b-form-group>
                            </b-col>
                            <b-col> <!--  style="background-color: rgba(255,180,0,0.1);" -->
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
            <!-- <p>Alumno:<br>{{alumno}}</p>
            <p>Seleccionado: <br>{{seleccionado}}</p> -->
        </div>
        </template>
    </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import Curso from '@/components/Curso.vue'
import CabeceraPlanilla from '@/components/CabeceraPlanilla.vue'
export default {
    name: 'Planilla',
    components: {
        Curso,
        CabeceraPlanilla
    },
    data() {
        return {
            seleccionado: [],
            indiceSel: -1,
            bug: 0,
            curso_id: 0,
            nombre: '',
            nota: [],
            puntero: 0,
            obs: '',
            verificado: false,
            estado_alumno: 'QRY',
            valoresObs: ['PA','RP','RT','NP'],
            alumno: {},
            alumnos: [],
            materias: [],
            campos: [
                {key: 'index', label: '#'},
                {key: 'nombres', label: 'Apellidos y Nombres', class: 'text-left'}
            ]
        }
    },
    created() {
        this.curso_id = this.$route.params.curso
        //console.log(cur)
        let curs = this.cursos.find(item => item._id === this.curso_id)
        this.agregarMiga({
            text: curs.nombre,
            to: {name: 'cursos', params: {curso: curs._id}}
        })
        //console.log(this.migas)
        this.obtenerMaterias(this.planilla[2].grado)
        //console.log('Materias:',this.materias)
        //console.log('Campos:', this.campos)
        //this.alumnos = this.alumnos.filter(item => item.cursoId === this.curso_id)
        this.obtenerAlumnos(this.curso_id)
    },
    computed: {
        ...mapState(['migas', 'cursos','planilla']),
        editar: {
            get () {return this.$store.state.mostrar_form_curso},
            set (valor) {this.$store.commit('mostrarFormCurso', valor)}
        },
        validarNombre() {
            let cars = this.nombre.length
            if (cars === 0) return null
            if (cars > 9) return true
            return false
        },
        validarObs(valor) {
            let cars = this.obs.length
            if (cars === 0) return null
            if (cars === 2 && this.valoresObs.includes(this.obs)) return true
            return false
        },
        validarCantidad() {
            let cant = this.nota.length
            //console.log(this.nota.mat.mat)
            if (cant === 0) return true
            if (cant === 1 || cant === 3) return true
            return false
        }
    },
    methods: {
        ...mapMutations(['agregarMiga']),
        formatear(valor) {
          return valor.toUpperCase()
        },
        obtenerEstilo(llave) {
            let estilo = Object.create({})
            const color = 'primary'
            this.$set(estilo, llave+'_pa', color)
            this.$set(estilo, llave+'_pr', color)
            this.$set(estilo, llave+'_pf', color)
            return estilo
        },
        onRowSelected(items) {
            this.seleccionado = items
            if (this.seleccionado.length > 0) {
                //console.log('seleccionado...')
                this.indiceSel = this.alumnos.map(e => e._id).indexOf(this.seleccionado[0]._id)
                //console.log(this.indiceSel)
            }
        },
        onRowClicked(record, index) {
            //console.log('Indice clickeado...'+index+' selecionado: '+this.indiceSel)
            if (this.seleccionado[0]) {
                if (record.nro === this.seleccionado[0].nro) {
                    this.indiceSel = -1
                }
                if(this.nombre) {
                    this.nombre = ''
                    this.obs = ''
                    this.verificado = false
                    this.nota = []
                    this.estado_alumno = 'QRY'
                }
                this.$refs.nombre.focus()
            }
        },
        onTeclaEnter(evento) {
            //console.log(event)
            if (this.validarCantidad) {
                this.agregarNota()
                //this.$refs.lenguaje.focus()
            }
        },
        onTeclaLeft(evento) {
            if (this.puntero > 0) {
                this.puntero--
                let clave = this.materias[this.puntero].key
                //console.log(clave)
                this.$set(this.nota,0, this.alumno[clave+'_pa'])
                this.$set(this.nota,1, this.alumno[clave+'_pr']===this.alumno[clave+'_pa']?this.alumno[clave+'_pr']+'.':this.alumno[clave+'_pr'])
                this.$set(this.nota,2, (this.alumno[clave+'_pf']!==null && (this.alumno[clave+'_pf']===this.alumno[clave+'_pa']||this.alumno[clave+'_pf']===this.alumno[clave+'_pr']))?this.alumno[clave+'_pf']+',':this.alumno[clave+'_pf'])
                //nuevo
                this.alumno['_cellVariants'] = this.obtenerEstilo(clave)
            }
        },
        onTeclaScape(evento) {
            this.quitarAlumno()
            if (this.estado_alumno === 'QRY') {
                this.nro = 0
                this.puntero = 0
                this.nombre = ''
                this.obs = ''
                this.verificado = false
                this.nota = []
                this.$refs.nombre.focus()
            }
        },
        onChangeCheckbox(checked) {
            if (this.estado_alumno === 'INS' || this.estado_alumno === 'UPD') {
                //console.log('Checkbox checked', checked)
                this.alumno.verificado = checked
            }
        },
        validarNota(valor) {
            return /^[1-9]\d{0,1}([+,.]){0,1}$/.test(valor) //nota.length > 0 && nota.length < 3 && 
        },
        agregarNota() {
            if (this.estado_alumno === 'INS' || this.estado_alumno === 'UPD') {
                console.log('Agregar nota: '+this.materias[this.puntero].key+' ['+this.puntero+'], estado: '+this.estado_alumno)
                let clave = this.materias[this.puntero].key
                this.alumno[clave+'_pa'] = this.nota[0]
                this.alumno[clave+'_pr'] = this.nota[1]===undefined?null:(this.nota[1]).replace(/[.,]+$/g,'')
                this.alumno[clave+'_pf'] = this.nota[2]===undefined?null:(this.nota[2]).replace(/[.,]+$/g,'')
                if (this.puntero +1 === this.materias.length) {
                    this.$refs.obs.focus()
                    //return
                } else {
                    this.nota = []
                    if (this.puntero +1 < this.materias.length) {
                        this.puntero++
                        //console.log('puntero: '+this.puntero+', len: '+this.materias.length)
                        clave = this.materias[this.puntero].key
                        if (this.alumno[clave+'_pa'] != null) {
                            this.$set(this.nota, 0, this.alumno[clave+'_pa'])
                            this.$set(this.nota, 1, this.alumno[clave+'_pr']===this.alumno[clave+'_pa']?this.alumno[clave+'_pr']+'.':this.alumno[clave+'_pr'])
                            this.$set(this.nota, 2, (this.alumno[clave+'_pf']!==null && (this.alumno[clave+'_pf']===this.alumno[clave+'_pa']||this.alumno[clave+'_pf']===this.alumno[clave+'_pr']))?this.alumno[clave+'_pf']+',':this.alumno[clave+'_pf'])
                        }
                        //nuevo
                        this.alumno['_cellVariants'] = this.obtenerEstilo(clave)
                    }
                }
            }
        },
        agregarObs() {
            console.log('Agregar obs: '+ this.alumno.obs+', estado: '+this.estado_alumno+', BUG='+this.bug)
            if ((this.estado_alumno === 'INS' || this.estado_alumno === 'UPD') && this.validarObs && this.bug > 0) {
                this.alumno.obs = this.obs
                if (this.estado_alumno === 'INS') {
                    //console.log('Alumno:',this.alumno)
                    this.axios.post('/alumnos', this.alumno)
                        .then(res => {
                            console.log(res.data)
                            this.alumnos.pop()
                            this.alumnos.push(res.data)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                } else if (this.estado_alumno === 'UPD') {
                    this.axios.put(`/alumnos/${this.alumno._id}`, this.alumno)
                        .then(res => {
                            console.log(res)
                        })
                        .catch(e => {
                            console.log(e)
                        })
                    this.$refs.alumnos.clearSelected()
                }
                this.estado_alumno = 'QRY'
                this.alumno['_cellVariants'] = {} //nuevo
                this.nro = 0
                this.puntero = 0
                this.nombre = ''
                this.obs = ''
                this.verificado = false
                this.nota = []
                this.$refs.nombre.focus()
                this.bug = 0
            }
            this.bug++
        },
        editarNombre(value) {
            if (this.validarNombre) {
                if (this.estado_alumno === 'QRY') {
                    this.iniciarAlumno()
                } else {
                    this.alumno.nombres = value
                }
            }
        },
        iniciarAlumno() {
            if (this.estado_alumno === 'QRY') {
                this.alumno = Object.create({})
                this.$set(this.alumno,'cursoId',0)
                this.$set(this.alumno,'nro',0)
                this.$set(this.alumno,'nombres','')
                this.materias.forEach(ma => {
                    this.$set(this.alumno,ma.key+'_pa',null)
                    this.$set(this.alumno,ma.key+'_pr',null)
                    this.$set(this.alumno,ma.key+'_pf',null)
                });
                this.$set(this.alumno,'obs','')
                this.$set(this.alumno,'verificado',false)
                this.$set(this.alumno,'_cellVariants',this.obtenerEstilo('mat')) //nuevo
                this.estado_alumno = 'NEW' 
                this.alumno.nro = this.alumnos.length +1
                this.alumno.nombres = this.nombre
                this.alumno.cursoId = this.curso_id
                this.agregarAlumno()
            }
        },
        agregarAlumno() {
            if (this.estado_alumno === 'NEW') {
                this.alumnos.push(this.alumno)
                this.estado_alumno = 'INS'
                this.bug = 0 //corregir tecla enter en obs
            }
        },
        quitarAlumno() {
            if (this.estado_alumno === 'NEW' || this.estado_alumno === 'INS') {
                this.alumnos.pop()
                this.estado_alumno = 'QRY'
            }
        },
        eliminarAlumno() {
            if (this.indiceSel > -1) {
                this.axios.delete(`/alumnos/${this.alumnos[this.indiceSel]._id}`)
                    .then(res => {
                        console.log('Eliminado:', res.data)
                    })
                    .catch(e => {
                        console.log(e)
                    })
                this.alumnos.splice(this.indiceSel,1)
                this.indiceSel = -1
            }
        },
        editarAlumno() {
            if (this.indiceSel > -1) {
                this.estado_alumno = 'UPD'
                this.bug = 0 //corregir tecla enter en obs
                this.alumno = this.alumnos[this.indiceSel]
                this.indiceSel = -1
                this.puntero = 0
                this.nombre = this.alumno.nombres
                this.obs = this.alumno.obs
                this.verificado = this.alumno.verificado
                this.nota = []
                let clave = this.materias[this.puntero].key
                if (this.alumno[clave+'_pa'] != null) {
                    this.$set(this.nota, 0, this.alumno[clave+'_pa'])
                    this.$set(this.nota, 1, this.alumno[clave+'_pr']===this.alumno[clave+'_pa']?this.alumno[clave+'_pr']+'.':this.alumno[clave+'_pr'])
                    this.$set(this.nota, 2, (this.alumno[clave+'_pf']!==null && (this.alumno[clave+'_pf']===this.alumno[clave+'_pa']||this.alumno[clave+'_pf']===this.alumno[clave+'_pr']))?this.alumno[clave+'_pf']+',':this.alumno[clave+'_pf'])
                }
                this.$set(this.alumno, '_cellVariants', this.obtenerEstilo(clave)) //nuevo
                this.$refs.nombre.focus()
            }
        },
        obtenerAlumnos(curso) {
            this.alumnos.splice(0)
            this.axios.get(`/alumnos/${curso}`)
                .then(res => {
                    this.alumnos = res.data
                })
                .catch(e => {
                    console.log(e)
                })
        },
        obtenerMaterias(grado) {
            this.materias.splice(0)
            this.axios.get(`/materias/${grado}`)
                .then(res => {
                    res.data.forEach(mat => {
                        this.materias.push({key: mat.sigla, label: mat.nombre})
                        this.campos.push({key: mat.sigla+'_pa', label: 'PA'})
                        this.campos.push({key: mat.sigla+'_pr', label: 'PR'})
                        this.campos.push({key: mat.sigla+'_pf', label: 'PF'})
                    })
                    this.campos.push({key: 'obs', label: 'Obs.'})
                    this.campos.push({key: 'verificado', label: '¿Verf.?'})
                })
                .catch(e => {
                    console.log(e)
                })
        }
    }
}
</script>

<!--<style scoped>
/deep/ .table > tbody > tr.b-table-row-selected,
/deep/ .table > tbody > tr.b-table-row-selected > td,
/deep/ .table > tbody > tr.b-table-row-selected > th {
    background-color: #91c27d;
}
</style> -->